import React from 'react';
import { addDays, endOfDay, startOfDay } from 'date-fns';
import { QueryResult, useQuery } from '@apollo/client';
import { fetchUpcomingRenewalsForTransactionAccount } from './queries/fetch-upcoming-renewals-for-transaction-account';
import { MAX_WIDGET_ITEMS } from '../../../constants/widget';
import {
  FetchUpcomingRenewalsForTransactionAccountInPpcQuery,
  FetchUpcomingRenewalsForTransactionAccountInPpcQueryVariables,
  SortDirection,
} from '@css-xp/graphtypes/src/generated-types-new';

type ChildrenProp = (
  args: QueryResult<
    FetchUpcomingRenewalsForTransactionAccountInPpcQuery,
    FetchUpcomingRenewalsForTransactionAccountInPpcQueryVariables
  >
) => JSX.Element;

export const UpcomingRenewalsQueryWrapper = ({
  txaId,
  children,
}: {
  txaId: string;
  children: ChildrenProp;
}): JSX.Element => {
  const queryResult = useQuery<
    FetchUpcomingRenewalsForTransactionAccountInPpcQuery,
    FetchUpcomingRenewalsForTransactionAccountInPpcQueryVariables
  >(fetchUpcomingRenewalsForTransactionAccount, {
    variables: {
      id: txaId,
      searchOptions: {
        first: MAX_WIDGET_ITEMS,
        sort: {
          sortFields: ['lastPeriodEndDate', 'id'],
          sortFieldsDirections: [SortDirection.ASC, SortDirection.ASC],
        },
      },
      filterOptions: [
        {
          key: 'not',
          // fetching only the subscriptions which are not app or sandbox types
          value:
            '[{"relatesFromEntitlementsRelationshipType":"ADDON_DEPENDENCE"},' +
            '{"relatesFromEntitlementsRelationshipType":"APP_DEPENDENCE"},' +
            '{"relatesFromEntitlementsRelationshipType":"SANDBOX_DEPENDENCE"}]',
        },
        {
          key: 'status',
          // fetching only the subscriptions which are active currently
          value: 'Active',
        },
        {
          key: 'lastPeriodEndDateIsGte',
          // fetching only the subscriptions having subscription period more than today
          value: startOfDay(new Date()).toISOString(),
        },
        {
          key: 'lastPeriodEndDateIsLte',
          // fetching only the subscriptions of last 90 days subscription period
          value: endOfDay(addDays(new Date(), 90)).toISOString(),
        },
      ],
    },
    skip: !txaId,
    fetchPolicy: 'cache-and-network',
  });
  return children(queryResult);
};
